<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">2022世界人工智能大会，腾讯云+AI驱动技术创新与场景创新双向融合</div>
      <div class="news-date">2022年9月3日</div>
      <div class="news-content">
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news17/news17_17.gif"/>
          </div>
        </div>
        <p>
          <span class="mark-text">9月3日，2022世界人工智能大会·腾讯论坛在上海举办，</span>
          聚焦“人工智能技术助力数字经济高质量发展”，腾讯展示了AI平台建设、产业应用、行业研究的最新成果。与此同时，
          <span class="mark-text">腾讯联合国家天文台公布以“AI+云”开启M31仙女座星系中脉冲星类致密天体的最深度完整探测，AI+天文跨界组合取得重大突破，成为大会关注焦点。</span>
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/newscenter/news22.jpeg"/>
          </div>
        </div>
        <p>
          大会期间，腾讯也公布了一系列AI创新的进展。在技术创新层面，
          <span class="mark-text">腾讯云TI平台</span>
          持续升级，通过“最佳实践”不断优化升级平台性能。全新的AI加速功能TI-ACC，训练加速性能较原生框架提升30%以上，作为腾讯首个面向开发者开放的一站式机器学习平台，让“开箱即用”的AI助力各行业实现降本增效。
        </p>
        <p>在场景创新层面，腾讯对外展示了云+AI在工业、金融、传媒、能源、交通等多个场景下的创新实践。国内首份金融AI白皮书《价值共生·2022金融AI发展研究报告》发布，全景呈现在数实融合加速的时代背景下，金融与AI深度融合创新所产生的积极影响和趋势洞察，以产学研的力量为AI+金融应用落地提出发展方向。</p>
        <p>
          在前沿技术探索上，2021年腾讯与国家天文台联合启动“探星计划”，用AI+云寻找脉冲星，提高探星效率。经过8个月的努力，优图AI天体探索方案已从巡天观测数据中寻找超过22个脉冲星候选体。
          <span class="mark-text">在世界人工智能大会上，国家天文台-腾讯天体AI探星计划获得世界人工智能大会SAIL之星奖(Super AI Leader)。</span>
        </p>
        <p>
          <span class="mark-text">腾讯云副总裁、腾讯优图实验室总经理吴运声表示：</span>
          “随着数字技术与实体经济加速融合，人工智能的发展不再局限于算力、算法、数据等方面的技术突破，而是从行业应用、社会需求的角度逐渐深入，展开一场‘双向奔赴’的范式变革。”
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/news22_1.jpeg"/>
            <span>腾讯云副总裁、腾讯优图实验室总经理 吴运声</span>
          </div>
        </div>
        <p>上海市经济和信息化委员会副主任张英，国家天文台FAST首席科学家李菂，腾讯公司副总裁、华东总部总经理张立军，腾讯互动娱乐品质管理部总经理、腾讯先锋云游戏总经理荆彦青，腾讯数字孪生产品副总裁万超，腾讯技术公益发起人、腾讯CDC总经理陈妍，腾讯安全管理部副总经理、腾讯知识产权部副总经理杨鹏，腾讯集团市场与公关部副总经理林涛，腾讯研究院副院长杜晓宇，奥运五金传奇冠军吴敏霞等重磅嘉宾出席了本次论坛。</p>
        <div class="news-content-mark">
          <h2>01</h2>
          <div>从技术创新到场景创新</div>
          <div>腾讯加速促进AI与实体产业融合</div>
        </div>
        <p>
          <span class="mark-text">腾讯公司副总裁、华东总部总经理张立军在致辞中表示，</span>
          作为一家科技公司，腾讯在服务10亿级用户的过程中，积累了丰富的自研技术。在新的国际形势下，腾讯正在打造自主可控的底层技术，不断探索创新。
          <span class="mark-text">目前，腾讯人工智能中国专利申请超过5600件，AI领域专利申请总量位于国内互联网公司第一。</span>
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/news22_2.jpeg"/>
            <span>腾讯公司副总裁、华东总部总经理 张立军</span>
          </div>
        </div>
        <p>如何让这些高深复杂的前沿算法和理论，转换成低门槛的“编程软件”，惠及更多中小企业，让“用得起”、“易上手”的AI进入千行百业。</p>
        <p>在工业领域，提升外观缺陷质检的效率与质量是3C企业的共性挑战。去年，腾讯与立铠精密达成合作，在了解到客户存在“硬件缺陷多样、成像复杂”等质检难题后，立即开展投入算法研究，为客户提供优图自研的AI质检算法，有效解决人工目视质检的难题，实现漏检率接近于0，每年节省超千万的支出，真正实现降本增效。</p>
        <p>
          <span class="mark-text">吴运声表示，腾讯的工业AI基础技术集中在工业成像、基础算法、高效学习以及仿真生成四个方面，通过这四部分能力已打造超过10个细分领域外观检测的解决方案。</span>
          结合规模化落地经验，腾讯云推出工业质检训练平台。作为面向工业外观缺陷检测场景，零基础工程师也能轻松使用的AI质检平台，拥有算法精准、部署灵活、简单易用、功能完备的特点，可以最大程度降低工业AI质检算法落地的技术门槛。
        </p>
        <p>
          当下，游戏技术也开始从“虚拟世界”走入实体产业。
          <span class="mark-text">荆彦青先生表示：</span>
          “超级数字生态浪潮正在到来。数字技术已经成为行业高质量发展的核心驱动力，成为推动行业转型升级的关键要素。随着科技的发展，超级数字生态也将快速渗透到各行各业，提升产业效率。在这个战略选择下，腾讯先锋云游戏依托独家自研核心技术，构建数字化生态全场景、全球化布局，发挥云游戏多场景、多内容的优势，与行业共创超级数字生态新体验。在人工智能、实体工业、天文科研、以及文化遗产保护等多个场景进行探索，推动云游戏技术在多行业的外延发展。”
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/news22_3.jpeg"/>
            <span>腾讯互动娱乐品质管理部总经理、腾讯先锋云游戏总经理 荆彦青</span>
          </div>
        </div>
        <p>
          与此同时，腾讯先锋还积极致力于探索虚实互动、无穿戴动捕及表情动画面捕等前沿技术创新和数字健康场景应用研究。基于腾讯先锋
          <span class="mark-text">自研云端虚实互动技术，实现4K精度的实时抠图，让用户使用普通摄像头或手机即可投射到虚拟场景中，通过连接虚拟与真实世界，为用户带来全新数字场景的互动体验。</span>
        </p>
        <p>从人工智能技术的积累，到多个创新场景的应用爆发。AI加速发展，将推动一个线上线下一体化、数字技术与真实世界融合的全真互联时代到来。</p>
        <p>其中，数字孪生技术以其逼真、实时、交互、可计算的特点反映物理实体的全生命周期，将物理世界和数字世界做了紧密连接，以更好地助力各行业数字化转型。</p>
        <p>
          <span class="mark-text">腾讯数字孪生产品副总裁万超在演讲中表示：</span>
          “腾讯在CIM、BIM、大数据、云计算、物联网、AI、模拟仿真等领域有深厚自研技术积累，同时在产业端也有一批创新实践，已经在交通、建筑、园区、城市、工业、水务等领域打造出数字孪生创新应用。”
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/news22_4.jpeg"/>
            <span>腾讯数字孪生产品副总裁 万超</span>
          </div>
        </div>
        <p>目前，基于对核心技术的打磨和对场景的深入探索，腾讯数字孪生体系内的行业机理模型和数据驱动模型更加完善，沉淀的能力也更加标准化、开放化、平台化，助力合作伙伴创造产业创新价值，共同打造蓬勃的行业生态。</p>
        <div class="news-content-mark">
          <h2>02</h2>
          <div>国内首份金融AI白皮书发布</div>
          <div>深化金融场景创新</div>
        </div>
        <p>面向通用场景做精应用、面向专有场景做深行业，联合广泛的伙伴生态，通过产学研的力量共同助力产业智能化升级。</p>
        <p>
          <span class="mark-text">本次论坛上，腾讯发布国内首份金融AI白皮书——《价值共生·2022金融AI发展研究报告》（以下简称“报告”）。报告由北京金融科技产业联盟作为指导单位，由腾讯研究院与腾讯优图实验室、腾讯云、交通银行组成的联合课题组，联动腾讯内部及金融机构业务侧，对国内多个金融机构进行了近五个月的调研，并将调研成果与课题组对金融AI的发展趋势思考进行汇总，共同编制而成。</span>
        </p>
        <p>报告分为三大章节，从政策、行业、趋势三个层面出发，详细阐述了金融AI的发展环境与机遇、典型场景与案例、发展趋势与展望，全景呈现在数实融合加速的时代背景下，金融与AI深度融合创新所产生的积极影响和趋势洞察。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/news22_5.jpeg"/>
            <span>发布《价值共生·2022金融AI发展研究报告》启动仪式</span>
          </div>
        </div>
        <p>
          <span class="mark-text">腾讯研究院副院长杜晓宇在发布现场做了《金融AI：人工智能浪潮下的金融变革》的分享。</span>
          他表示，人工智能是金融科技的重要组成部分，也是金融机构数字化转型的重要技术支撑。通过与金融业务的深度融合创新，人工智能赋能金融业务实现多方面的价值提升。不仅通过降本增效提升了银行价值，通过“千人千面”的7*24小时服务提升了客户价值，更通过解决信息不对称问题，着力解决小微企业信贷难题、切实服务实体经济，提升了社会价值。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/news22_6.jpeg"/>
            <span>腾讯研究院副院长 杜晓宇</span>
          </div>
        </div>
        <p>人工智能已成为金融机构创新发展的重要驱动力。在与交通银行的合作中，腾讯以多模态融合应用于计算机视觉研究，为交通银行提供多个场景下的视觉AI解决方案，可以快速处理用户上传图片不清晰、用户证件照片识别、资料印章模糊干扰、用户证件PS鉴伪等问题，提升银行交易流程效率和用户办理业务体验。</p>
        <p>
          <span class="mark-text">腾讯研究院副秘书长杨望认为，</span>
          未来随着金融机构、科技企业的持续深入创新合作，金融AI的应用场景将不断扩展、深化，助力数实融合，推动金融科技朝着可信、智能、安全、普惠的方向迈进。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/news22_7.jpeg"/>
            <span>腾讯研究院副秘书长 杨望</span>
          </div>
        </div>

        <div class="news-content-mark">
          <h2>03</h2>
          <div>探星计划发现22颗脉冲星，云+AI助力天眼FAST脉冲星识别速度提升120倍</div>
        </div>
        <p>以“科技向善”为牵引，人工智能的应用不仅面对当下，也看向未来。</p>
        <p>
          <span class="mark-text">去年，腾讯与国家天文台合作正式启动“探星计划”，基于优图实验室计算机视觉技术、腾讯云领先的计算及存储能力，用“云+AI”帮助中国天眼FAST处理每天接收到的庞大数据，并通过视觉AI分析找到脉冲星线索，在同等算力下处理效率提高了120倍。</span>
        </p>
        <p>经过一年的合作，腾讯首次对外披露“探星计划”进展。</p>
        <p>
          吴运声表示，截至目前，
          <span class="mark-text">优图AI天体探索方案已从巡天观测数据中找到22颗脉冲星。</span>
          其中，包括在天体物理中具有较高观测研究价值的高速自转的毫秒脉冲星7颗，具有间歇辐射现象的年老脉冲星6颗。此外，优图动态谱AI模型还首次探测到了某磁陀星射电脉冲。
        </p>
        <p>探索宇宙的脚步持续向前，2022年腾讯与国家天文台共同开启对M31仙女座星系的射电信号处理，这也是天文界对该星系中脉冲星类致密天体的最深度完整探测。</p>
        <p>
          <span class="mark-text">在本次大会上，国台-腾讯天体AI探星计划获颁发世界人工智能大会SAIL之星奖(Super AI Leader)。</span>
          腾讯优图、国家天文台、澎湃新闻、微信视频号、腾讯云、腾讯音乐娱乐集团、腾讯地图、星联CSVA还将联合发起 “寻找宇宙心跳”——脉冲星演奏会，22颗脉冲星联合出演，带领大家共同探索宇宙的奥秘。
        </p>
        <p>寻找场景创新，促进AI与实体产业深度融合，注定是一场长跑。只有加强AI相关的云计算、大数据、数字孪生等前沿技术研究，探索实践，才能把握新一轮产业变革机会，助力数实融合。面向未来，腾讯也将持续精进AI技术与开放平台的产品创新能力，为企业和开发者提供更加丰富的平台化服务。</p>
      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News22',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  margin: 0 auto;
  .news-content-mark {
    margin-top: 40px;
    margin-bottom: 20px;
    div {
      margin: 0;
    }
    h2 {
      margin-bottom: 15px;
    }
  }
  .image-panel {
    max-width: 667px;
    text-align: center;
    img {
      max-width: 667px;
    }
    span {
      font-size: 12px;
      color: #858585;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News22.vue